import { Redirect } from "react-router-dom";

import { SentryRoute } from "sentry";

export const LEGACY_REDIRECTS = [
  { from: "/transactions/payments", to: "/gateway/payments" },
  { from: "/transaction/mandates", to: "/gateway/mandates" },
  { from: "/transactions/refunds", to: "/connect/refunds" },
  { from: "/transactions/payouts", to: "/connect/payouts" },
  { from: "/transactions/settlements", to: "/connect/settlements" },
  { from: "/accounts/overview", to: "/connect/overview" },
  { from: "/transactions", to: "/gateway/payments" },
] as const;

export const legacyRedirectRoutes = LEGACY_REDIRECTS.map(({ from, to }) => (
  <SentryRoute
    key={from}
    path={from}
    render={({ location }) => (
      <Redirect
        to={{
          ...location,
          pathname: location.pathname.replace(from, to),
        }}
      />
    )}
  />
));
